package empiresmp.feature.shop.ui

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import empiresmp.components.FilledText
import empiresmp.feature.shop.backend.model.PublicShopItemData
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import ru.astrainteractive.kobwebx.core.resource.Resources
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette
import ru.astrainteractive.kobwebx.core.theme.util.ThemeExt.typography

@Composable
@Suppress("LongMethod")
internal fun ShopItemCard(
    itemData: PublicShopItemData,
    modifier: Modifier = Modifier,
    buttonText: String = "Купить",
    isEnabled: Boolean = true,
    onClick: () -> Unit
) {
    val theme = LocalSitePalette.current

    Column(
        modifier = modifier
            .width(12.em)
            .minHeight(14.em)
            .clip(Rect(theme.dimens.S))
            .background(theme.colors.colorPrimary)
            .padding(theme.dimens.S),
        verticalArrangement = Arrangement.SpaceBetween,
        horizontalAlignment = Alignment.Start
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(theme.dimens.S)
        ) {
            Image(
                src = itemData.iconBase64,
                modifier = Modifier
                    .size(64.px)
                    .borderRadius(theme.dimens.S)
            )
            Column(
                verticalArrangement = Arrangement.spacedBy(theme.dimens.XS),
                horizontalAlignment = Alignment.Start
            ) {
                SpanText(
                    text = "${itemData.title}",
                    modifier = theme.typography.h3.toModifier()
                        .padding(left = theme.dimens.XS)
                        .color(theme.colors.colorOnPrimary)
                )
                Row(
                    modifier = Modifier
                        .clip(Rect(theme.dimens.S))
                        .padding(leftRight = theme.dimens.XS)
                        .background(theme.colors.colorPrimaryVariant),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText(
                        text = "${itemData.totalPrice}",
                        modifier = theme.typography.body1.toModifier()
                            .color(theme.colors.colorOnPrimary)
                    )
                    Image(
                        src = Resources.tgStar.path,
                        modifier = Modifier
                            .size(22.px)
                            .borderRadius(theme.dimens.S)
                    )
                }
            }
        }
        SpanText(
            text = itemData.description,
            modifier = theme.typography.body1.toModifier()
                .color(theme.colors.colorOnPrimary)
                .fontWeight(FontWeight.SemiBold)
        )
        itemData.smallDesc?.let { smallDesc ->
            SpanText(
                text = smallDesc,
                modifier = theme.typography.body2.toModifier()
                    .color(theme.colors.colorHintOnPrimary)
                    .fontWeight(FontWeight.Normal)
            )
        }
        FilledText(
            text = buttonText,
            fillColor = when {
                isEnabled -> theme.colors.colorSecondaryVariant
                else -> theme.colors.colorSecondaryVariant.toRgb().copy(alpha = 150)
            },
            textColor = theme.colors.colorOnSecondaryVariant,
            modifier = Modifier
                .fillMaxWidth()
                .textAlign(TextAlign.Center)
                .thenIf(!isEnabled, Modifier.cursor(Cursor.Default)),
            onClick = {
                onClick.invoke()
            }
        )
    }
}
